/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { appRoute } from "@/router/routes/AppRoute";
import { bootstrapRoute } from "@/router/routes/BootstrapRoute";
import { loginRoute } from "@/router/routes/LoginRoute";
import { nftRoute } from "@/router/routes/NftRoute";
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter)

export const router = new VueRouter({
    base: process.env.BASE_URL,
    mode: 'history',
    routes: [
        ...appRoute,
        ...bootstrapRoute,
        ...loginRoute,
        ...nftRoute,
    ] as RouteConfig[],
})

export const isUuid4 = (param: string): boolean => /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(param)
